import { clearTrackingEvents, setTrackingEvents } from '../../services/trackingService';
import './shows.component.scss';

export default function ShowsView() {
    return {
        oncreate: () => setTrackingEvents('a.target-link', 'shows'),
        onremove: () => clearTrackingEvents('a.target-link'),
        view: () => (<>
            <div class="headline">
                <h2>Upcoming Dates</h2>
            </div>
            <div class="content shows-content">
                <div class="content__col content__col--shows">
                    <div class="box-border-rough">
                        <script charset="utf-8" src="https://widgetv3.bandsintown.com/main.min.js"></script>
                        <a class="bit-widget-initializer"

                        data-artist-name="id_15560541"

                        data-events-to-display=""
                        data-background-color="rgba(255,255,255,0)"
                        data-separator-color="rgba(0,0,0,1)"
                        data-text-color="rgba(0,0,0,1)"
                        data-font="Roboto"
                        data-auto-style="true"

                        data-button-label-capitalization="uppercase"
                        data-header-capitalization="uppercase"
                        data-location-capitalization="uppercase"
                        data-venue-capitalization="uppercase"
                        data-display-local-dates="true"
                        data-local-dates-position="tab"
                        data-display-past-dates="true"
                        data-display-details="true"
                        data-display-lineup="true"
                        data-display-start-time="true"
                        data-social-share-icon="true"
                        data-display-limit="all"

                        data-date-format="MMM. D, YYYY"
                        data-date-orientation="horizontal"
                        data-date-border-color="#4A4A4A"
                        data-date-border-width="1px"
                        data-date-capitalization="capitalize"
                        data-date-border-radius="10px"

                        data-event-ticket-cta-size="medium"
                        data-event-custom-ticket-text=""
                        data-event-ticket-text="TICKETS"
                        data-event-ticket-icon="false"
                        data-event-ticket-cta-text-color="rgba(255,255,255,1)"
                        data-event-ticket-cta-bg-color="rgba(0,0,0,1)"
                        data-event-ticket-cta-border-color="rgba(74,74,74,1)"
                        data-event-ticket-cta-border-width="0px"
                        data-event-ticket-cta-border-radius="2px"

                        data-sold-out-button-text-color="rgba(255,255,255,1)"
                        data-sold-out-button-background-color="rgba(74,74,74,1)"
                        data-sold-out-button-border-color="rgba(74,74,74,1)"
                        data-sold-out-button-clickable="true"

                        data-event-rsvp-position="left"
                        data-event-rsvp-cta-size="medium"
                        data-event-rsvp-only-show-icon="false"
                        data-event-rsvp-text="RSVP"
                        data-event-rsvp-icon="false"
                        data-event-rsvp-cta-text-color="rgba(0,0,0,1)"
                        data-event-rsvp-cta-bg-color="rgba(255,255,255,1)"
                        data-event-rsvp-cta-border-color="rgba(74,74,74,1)"
                        data-event-rsvp-cta-border-width="1px"
                        data-event-rsvp-cta-border-radius="2px"

                        data-follow-section-position="top"
                        data-follow-section-alignment="center"
                        data-follow-section-header-text="Get updates on new shows, new music, and more"
                        data-follow-section-cta-size="medium"
                        data-follow-section-cta-text="FOLLOW"
                        data-follow-section-cta-icon="false"
                        data-follow-section-cta-text-color="rgba(255,255,255,1)"
                        data-follow-section-cta-bg-color="rgba(0,0,0,1)"
                        data-follow-section-cta-border-color="rgba(74,74,74,1)"
                        data-follow-section-cta-border-width="0px"
                        data-follow-section-cta-border-radius="2px"

                        data-play-my-city-position="hidden"
                        data-play-my-city-alignment="center"
                        data-play-my-city-header-text="Don't see a show near you?"
                        data-play-my-city-cta-size="medium"
                        data-play-my-city-cta-text="REQUEST A SHOW"
                        data-play-my-city-cta-icon="false"
                        data-play-my-city-cta-text-color="rgba(255,255,255,1)"
                        data-play-my-city-cta-bg-color="rgba(0,0,0,1)"
                        data-play-my-city-cta-border-color="rgba(74,74,74,1)"
                        data-play-my-city-cta-border-width="0px"
                        data-play-my-city-cta-border-radius="2px"

                        data-optin-font=""
                        data-optin-text-color=""
                        data-optin-bg-color=""
                        data-optin-cta-text-color=""
                        data-optin-cta-bg-color=""
                        data-optin-cta-border-width=""
                        data-optin-cta-border-radius=""
                        data-optin-cta-border-color=""

                        data-language="en"
                        data-layout-breakpoint="900"
                        data-app-id=""
                        data-affil-code=""
                        data-bit-logo-position="bottomRight"
                        data-bit-logo-color="rgba(0,0,0,1)"

                        ></a>
                    </div>
                </div>
            </div>
        </>),
    };
}

/*
import shows from '../../data/shows.data.json';

const showsData = [];

shows.forEach((showData) => {
    const showDateTime = new Date(`${showData.date}T00:00:00.000-07:00`);
    const showDateFormatted = showDateTime.toDateString();
    const showDate = <h2>{showDateFormatted}</h2>;
    const flyerImg = showData.flyer ? <div class="show-flyer"><img src={showData.flyer} /></div> : '';
    const showClass = showData.flyer ? 'show show-wide' : 'show';
    const venue = showData.venue.url ? <a href={showData.venue.url} target="blank"><h3>{showData.venue.name}</h3></a> : <h3>{showData.venue.name}</h3>;
    const venueAddr = showData.venue.address && <div>{showData.venue.address}</div>;

    const bands = [];
    showData.bands.forEach((band) => {
        bands.push(
            <div class="band">
                {band.url ? <a href={band.url} target="blank">{band.name}</a> : band.name}
            </div>
        );
    });

    const extras = [];
    showData.extra.forEach((extra) => {
        extras.push(
            <div>{extra}</div>
        );
    });

    showsData.push(
        <div class={showClass}>
            {flyerImg}
            <div class="show-details">
                <div>{showDate}</div>
                <div>{venue}{venueAddr}</div>
                <div>{bands}</div>
                {extras.length > 0 && <div>{extras}</div>}
            </div>
        </div>
    );
})

export default function ShowsView() {
    return {
        view: () => (<>
            <div class="headline">
                <h2>Upcoming Shows</h2>
            </div>
            <div class="content shows-content">
                {showsData}
            </div>
        </>),
    };
}
*/
